/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type PermissionAccessLevel = typeof PermissionAccessLevel[keyof typeof PermissionAccessLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionAccessLevel = {
  None: 'None',
  Read: 'Read',
  Edit: 'Edit',
} as const;
